import React from 'react';
import FeedbackComment from 'donor/portal/pages/FeedbackDashboard/Feedback/FeedbackComment';
import { useFeedback } from '../FeedbackProvider';
import { FeedbackCommentProps } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { FeedbackSectionId } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { useUserActions } from 'shared/auth/hooks/useUserActions';
import {
  deleteQuestionLevelComment,
  updateQuestionLevelComment,
} from 'donor/portal/pages/FeedbackDashboard/Feedback/api';
import { isCommentNewSinceResolved } from './utils';

interface FeedbackCommentsProps {
  reportId: number;
  questionId: number;
  isCustomQuestion: boolean;
  sectionId: FeedbackSectionId;
  comments: FeedbackCommentProps[];
}

const FeedbackComments: React.FC<FeedbackCommentsProps> = ({
  reportId,
  questionId,
  isCustomQuestion,
  sectionId,
  comments,
}) => {
  const {
    addOrUpdateCommentState,
    deleteCommentState,
    getLastResolvedAt,
  } = useFeedback();
  const { userId, userType, email, name } = useUserActions();
  const currentUserId = userId ? userId.toString() : undefined;
  const resolvedAt = getLastResolvedAt(questionId);

  const onSuccessSave = (c: FeedbackCommentProps, i: number): void => {
    addOrUpdateCommentState(questionId, c, i, isCustomQuestion);
  };
  const onSuccessDelete = (i: number): void => {
    deleteCommentState(questionId, i);
  };

  return (
    <>
      {comments.map((c, i) => {
        return (
          <FeedbackComment
            key={c.commentId || i}
            index={i}
            isNew={isCommentNewSinceResolved(c, resolvedAt)}
            comment={{
              userId: c.userId,
              commentId: c.commentId,
              createdAt: c.createdAt,
              name: c.name,
              text: c.text,
              accountType: c.accountType,
              details: c.details,
              email: c.email,
              updatedAt: c.createdAt,
            }}
            reportId={reportId}
            sectionId={sectionId}
            currentUserName={name}
            currentUserType={userType}
            currentUserEmail={email}
            currentUserId={currentUserId}
            handleDelete={deleteQuestionLevelComment}
            handleSave={updateQuestionLevelComment}
            onSuccessSave={onSuccessSave}
            onSuccessDelete={onSuccessDelete}
          />
        );
      })}
    </>
  );
};

export default FeedbackComments;
